import { initializeApp } from "firebase/app";
import { setConsent } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import * as Sentry from "@sentry/react";
import { getGaIds, logAnalyticsSafe } from "./purchase_analytics";
import { onConsent } from "../Localization/useCookieBot";

export const firebaseConfig = {
    apiKey: "AIzaSyDI4CBfCWfhZ01sla0iYl8fUo7tRgL8thA",
    authDomain: "metastream-cars.firebaseapp.com",
    projectId: "metastream-cars",
    storageBucket: "metastream-cars.firebasestorage.app",
    messagingSenderId: "515143651496",
    appId: "1:515143651496:web:6e6a330603196e6fe5729d",
    measurementId: "G-6QGZCZYMVG"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig, { automaticDataCollectionEnabled: false });
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);
export const auth = getAuth(app);

// Storage
export const storage = getStorage(app);
export const storage_eu = getStorage(app, "gs://carskaut");

export function logAnalytics(name, additional_params = {}) {
    logAnalyticsSafe(name, additional_params);
}

export function logError(e) {
    if (!e) return;

    try {
        const error = e instanceof Error
            ? e
            : new Error(typeof e === "string" ? e : JSON.stringify(e));

        Sentry.captureException(error);
        logAnalytics("error", {
            error_name: error?.name ?? "UnknownError",
            message: error?.message?.slice(0, 100) ?? "unknown",
        });
    } catch (e) {
        console.error(e);
    }
}

// FUNCTIONS
const functions = getFunctions(app, "europe-west1");

const { hostname } = window.location;

const isFunctionsEmulatorON = true;
if (process.env.NODE_ENV === "development" && isFunctionsEmulatorON && !hostname.includes("192.168.0.100")) {
    console.log("connectFunctionsEmulator");
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}
const callableOptions = {
    limitedUseAppCheckTokens: true,
};

const initCallFunction = (name, options = {}) =>
    httpsCallable(functions, name, {
        ...callableOptions,
        ...options,
    });

export const askResultAI = initCallFunction("askResultAI");
export const submitContactForm = initCallFunction("submitContactForm");
export const submitInfluencerForm = initCallFunction("submitInfluencerForm");
export const vin_decode = initCallFunction("vin_decode");
// GoPay
export const getGopayStatus = initCallFunction("getGopayStatus");
const createGopayPaymentFunc = initCallFunction("createGopayPayment");
export const createGopayPayment = async (data) => {
    let ga_ids = {};
    try {
        ga_ids = await getGaIds();
    } catch (e) { }
    return createGopayPaymentFunc({ ...data, ...ga_ids })
}

// Status
export const getResult = initCallFunction("getResult");

//#region Cookies + policy
// Full default
const fullConsent = {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

// Consent Required Always
const partialConsent = {
    ad_personalization: "denied",
    ad_storage: "granted",
    ad_user_data: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

export function setDefaultConsent() {
    setConsent(partialConsent);
    if (window?.gtag) {
        window.gtag("consent", partialConsent);
    }
    if (window?.fbq) {
        window.fbq("consent", "revoke");
    }
}

export function setFullConsent() {
    setConsent(fullConsent);
    if (window?.gtag) {
        window.gtag("consent", fullConsent);
    }
    if (window?.fbq) {
        window.fbq("consent", "grant");
    }
}
//#endregion

export function generateUID(uidLength = 20) {
    const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let autoId = "";
    for (let i = 0; i < uidLength; i++) {
        autoId += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return autoId;
};